(function () {
  Chart.spiralGrid = function (params) {
    const data = params.data;
    const formato = params.formato;
    const el = params.el;
    const partido = params.partido;

    let box = new Box({
      size: { width: 2400, height: 2400 },
      padding: 20,
    });

    let svg = null;
    let gEspiral = null;

    const colorDefuncion = d3
      .scaleLinear()
      .domain([0, 100])
      .range(["#e68484", "#e72e2e"]);

    const colorHospitalizacion = d3
      .scaleLinear()
      .domain([0, 100])
      .range(["#ffeeff"], "#ff9f45");

    function setup() {
      crearSVG(el);
      crearEspiral();
      //crearLeyenda();
    }

    function crearSVG(wrapper) {
      svg = wrapper
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr("viewBox", `0 0 ${box.width} ${box.height + 200}`);

      svg = svg.append("g");

      svg = svg
        .append("g")
        .attr(
          "transform",
          `translate(${box.padding.left}, ${box.padding.top})`,
        );

      gEspiral = svg
        .append("g")
        .attr("data-g", "gEspiral")
        .attr(
          "transform",
          `translate(${box.content.width / 2}, ${box.content.height / 2})`,
        );
    }

    function crearEspiral() {
      let arreglo = [];
      let objeto = {};

      let anios = [2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025];
      let meses = [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ];

      _.each(anios, function (a) {
        _.each(meses, function (m) {
          let anio_mes = `${a}-${m}`;
          objeto[anio_mes] = {
            anio_mes: anio_mes,
            anio: +a,
            mes: +m,
            edades: [
              { grupo: "MAYOR", valor: 0 },
              { grupo: "ADULTO", valor: 0 },
              { grupo: "JOVEN", valor: 0 },
            ],
          };
        });
      });

      _.each(data, function (d) {
        if (objeto.hasOwnProperty(d.anio_mes)) {
          let o =
            _.find(objeto[d.anio_mes].edades, {
              grupo: d.demografia_edad,
            }) || false;
          if (o) {
            o.valor = d.tasa_defuncion;
          }
        }
      });
      arreglo = _.values(objeto);

      const spiralArc = (fromRadius, toRadius, width, fromAngle, toAngle) => {
        const x1 = fromRadius * Math.sin(fromAngle);
        const y1 = fromRadius * -Math.cos(fromAngle);
        const x2 = (fromRadius + width) * Math.sin(fromAngle);
        const y2 = (fromRadius + width) * -Math.cos(fromAngle);
        const x3 = toRadius * Math.sin(toAngle);
        const y3 = toRadius * -Math.cos(toAngle);
        const x4 = (toRadius + width) * Math.sin(toAngle);
        const y4 = (toRadius + width) * -Math.cos(toAngle);
        return `
    M ${x1},${y1}
    L ${x2},${y2}
    A ${fromRadius},${fromRadius} 1 0 1 ${x4},${y4}
    L ${x3},${y3}
    A ${fromRadius},${fromRadius} 0 0 0 ${x1},${y1}`;
      };

      const WIDTH = 30;
      const BASE_RADIUS = 200;
      const angle = (Math.PI * 2) / 12;
      const RADIUS_SCALE = 4.5;

      let index = 0;
      _.each(arreglo, function (o) {
        const fromAngle = angle * index;
        const toAngle = angle * (index + 1);

        let level = 0;
        _.each(o.edades, function (e) {
          const fromRadius =
            BASE_RADIUS + index * 2 * RADIUS_SCALE + WIDTH * level;
          const toRadius =
            BASE_RADIUS + (index + 1) * 2 * RADIUS_SCALE + WIDTH * level;
          const path = spiralArc(
            fromRadius,
            toRadius,
            WIDTH,
            fromAngle,
            toAngle,
          );
          //const color = `rgb(0,${192 + Math.random() * 64},255)`;
          gEspiral
            .append("path")
            .attr("d", path)
            .style("fill", e.valor == 0 ? "#f0f0f0" : colorDefuncion(e.valor))
            .style("stroke", "#d6d5d5");
          level++;
        });
        index++;
      });

      /*
      for (let index = 0; index < 8 * 12; index++) {
        const fromAngle = angle * index;
        const toAngle = angle * (index + 1);
        console.log(
          `index: ${index} - fromAngle: ${fromAngle} - toAngle: ${toAngle}`,
        );
        for (let level = 0; level < 5; level++) {
          const fromRadius =
            BASE_RADIUS + index * 2 * RADIUS_SCALE + WIDTH * level;
          const toRadius =
            BASE_RADIUS + (index + 1) * 2 * RADIUS_SCALE + WIDTH * level;
          console.log(`fromRadius: ${fromRadius} - toRadius: ${toRadius}`);
          const path = spiralArc(
            fromRadius,
            toRadius,
            WIDTH,
            fromAngle,
            toAngle,
          );
          const color = `rgb(0,${192 + Math.random() * 64},255)`;
          g.append("path").attr("d", path).style("fill", color);
        }
      }
      */
    }

    return setup();
  };
})();
